import { createContext, useContext, type ReactNode } from "react";
import type { DataSource } from "./DataSource";

const DataSourceContext = createContext<DataSource | null>(null);

export function DataProvider({ source, children }: { source: DataSource; children: ReactNode }) {
  return <DataSourceContext.Provider value={source}>{children}</DataSourceContext.Provider>;
}

export function useDataSource(): DataSource {
  const source = useContext(DataSourceContext);
  if (!source) throw new Error("useDataSource must be used inside DataProvider");
  return source;
}
